import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import {
  Container,
  Assumption,
  Content,
  Description,
  ImageContainer,
  HorizontalRule,
  InformationContainer,
  Information,
  MobileImage,
  DescriptionList,
  SectionHeader,
} from '@components/Internship/Assumptions/styles';
import TextHeader, { SIZE, WEIGHT, TAG } from '@components/TextHeader';
import Link from '@components/Link';
import Button, { BUTTON_TYPE, BUTTON_SIZE, BUTTON_THEME } from '@components/Button';

// import { useParallax, ParallaxProvider } from 'react-scroll-parallax';

import Assumption1 from '@assets/images/assumptions1.svg';
import Assumption2 from '@assets/images/assumptions2.svg';
import Assumption3 from '@assets/images/assumptions3.svg';
import Assumption4 from '@assets/images/assumptions4.svg';

const LAUREATES_LIST_IS_AVAILABLE = true;

function Assumptions() {
  const { t } = useTranslation('internship');
  return (
    <>
      <Container>
        <TextHeader size={SIZE.LG} weight={WEIGHT.NORMAL} tag={TAG.H2}>
          {t('Project assumptions')}
        </TextHeader>
        <Assumption type="rtl">
          <Content>
            <SectionHeader>{t('For whom?')}</SectionHeader>
            <Description dangerouslySetInnerHTML={{ __html: t('Assemption desc') }} />
            <SectionHeader>{t('Project goals')}</SectionHeader>
            <DescriptionList dangerouslySetInnerHTML={{ __html: t('Project desc') }} />
          </Content>
          <ImageContainer type="bottom">
            <Image src={Assumption1} />
          </ImageContainer>
        </Assumption>
        <Assumption type="ltr">
          <Content>
            <SectionHeader>{t('Assumptions')}</SectionHeader>
            <DescriptionList dangerouslySetInnerHTML={{ __html: t('Assumptions list') }} />
          </Content>
          <ImageContainer>
            <Image src={Assumption2} />
          </ImageContainer>
        </Assumption>
        <Assumption type="rtl">
          <Content>
            <SectionHeader>{t('Assumptions cont.')}</SectionHeader>
            <DescriptionList dangerouslySetInnerHTML={{ __html: t('Assumptions list cont.') }} />
          </Content>
          <ImageContainer type="right">
            <Image src={Assumption3} />
          </ImageContainer>
        </Assumption>
        <Assumption type="ltr">
          <Content>
            <MobileImage>
              <Image src={Assumption4} />
            </MobileImage>
            <SectionHeader>{t('Candidate Selection')}</SectionHeader>
            <DescriptionList dangerouslySetInnerHTML={{ __html: t('Candidate Selection desc') }} />
            <SectionHeader>
              {t(`laureates.${LAUREATES_LIST_IS_AVAILABLE ? 'available' : 'inProgress'}.title`)}
            </SectionHeader>
            <Description>
              {LAUREATES_LIST_IS_AVAILABLE ? (
                <Button
                  type={BUTTON_TYPE.BUTTON}
                  size={BUTTON_SIZE.MEDIUM}
                  buttonTheme={BUTTON_THEME.SECONDARY}
                  href="/lista-laureatow-2026"
                >
                  {t(`laureates.${LAUREATES_LIST_IS_AVAILABLE ? 'available' : 'inProgress'}.description`)}
                </Button>
              ) : (
                <span
                  dangerouslySetInnerHTML={{
                    __html: t(`laureates.${LAUREATES_LIST_IS_AVAILABLE ? 'available' : 'inProgress'}.description`),
                  }}
                />
              )}
            </Description>
          </Content>
          <ImageContainer className="last-assumption">
            <Image src={Assumption4} />
          </ImageContainer>
        </Assumption>
      </Container>
      <HorizontalRule />
      <InformationContainer>
        <Information>
          <TextHeader size={SIZE.MD} weight={WEIGHT.MEDIUM} tag={TAG.H3}>
            {t('Important dates in 2022')}
          </TextHeader>
          <Description colorStrong dangerouslySetInnerHTML={{ __html: t('Important dates desc') }} />
        </Information>
        <Information>
          <TextHeader size={SIZE.MD} weight={WEIGHT.MEDIUM} tag={TAG.H3}>
            {t('Any question?')}
          </TextHeader>
          <Description dangerouslySetInnerHTML={{ __html: t('Contact') }} />
          <Link href="/documents/regulamin-projektu-staze-wakacyjne-2024">{t('Download the project regulations')}</Link>
        </Information>
      </InformationContainer>
    </>
  );
}

export default Assumptions;
